/* src/app/request-form/request-form.component.scss */
:host ::ng-deep a {
  text-decoration: underline;
}
:host ::ng-deep .time-select {
  display: flex;
  flex-direction: row;
  align-items: center;
}
:host ::ng-deep .time-select input {
  max-width: 5em;
}
:host ::ng-deep .form-row {
  margin-left: 0;
}
:host ::ng-deep input,
:host ::ng-deep textarea {
  border-radius: 0;
  resize: none;
}
:host ::ng-deep h4 {
  margin-top: 1em;
}
:host ::ng-deep label:has(~ .error) {
  color: #C91913;
}
.date-separator {
  position: relative;
  left: 30px;
}
.time-separator {
  position: relative;
  left: 24px;
}
.form-group {
  margin-bottom: 0px !important;
}
.request-date-row {
  height: 77px;
}
.error-container {
  margin-top: -20px;
  margin-bottom: 20px;
}
.submitButton:enabled {
  color: white;
}
.am-pm {
  max-height: 21px;
}
.submit-failure {
  padding-top: 4px;
}
.btn-link {
  font-size: 14px;
}
/*# sourceMappingURL=request-form.component.css.map */
